import React, { useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import { useCurrentEditor } from '@tiptap/react';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import ImageIcon from '@mui/icons-material/Image';

const ToolbarImageButton = () => {
	const { editor } = useCurrentEditor();
	const fileInputRef = useRef();

	const handleChange = (e) => {
		console.log('ON CHANGE', e);
		const files = Array.from(e.target.files); //[0];

		// if (!file) return;

		// const reader = new FileReader();
		// reader.onload = () => {
		// 	console.log('reader.result', reader.result);
		// 	editor.chain().focus().setImage({ src: reader.result }).run();
		// };
		files.forEach((file) => {
			const fileReader = new FileReader();

			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				editor
					.chain()
					.insertContentAt(editor.state.selection.anchor, {
						type: 'image',
						attrs: {
							src: fileReader.result,
						},
					})
					.focus()
					.run();
			};
		});

		// reader.readAsDataURL(file);
		// e.target.value = null;
	};

	return (
		<Box>
			<input
				type='file'
				accept='image/png, image/jpeg, image/gif'
				onChange={handleChange}
				style={{ display: 'none' }}
				ref={fileInputRef}
				id={'toolbar-image-upload'}
			/>
			<label htmlFor={'toolbar-image-upload'}>
				<IconButton size='small' component='span'>
					<InsertPhotoOutlinedIcon />
				</IconButton>
			</label>
		</Box>
	);
};

export default ToolbarImageButton;
